<template>
  <v-container fluid>
    <v-row no-gutters justify="space-between">
      <h2 class="text-h4">{{$t('domains.title')}}</h2>
      <action-button
        id="pfid1618820491" 
        v-if="isOwner || isHelpdesk"
        :to="{name: 'add-domain'}"
        icon="$add"
        :tooltip="$t('domains.new')"
        color="success"
        fab
        small
        dark
      />
    </v-row>
    <v-row v-if="item && list && list.length > 0 && !loading"
      id="pfid1618820528">
      <v-col xs="12" md="6" lg="4" xl="3" v-for="d in list" :key="d.id">
        <v-card :to="isItemIncomplete(d) ? { name: 'domain-overview', params: {domain: d.id} } : { name: 'domain-dashboard', params: {domain: d.id} }" color="primary" class="fill-height">
          <v-card-title
            ><v-icon dark left>$domain</v-icon><span style="width: 85%" class="white--text overflow-hidden text-no-wrap">{{ d.name }}</span></v-card-title
          >
          <v-list>
            <v-list-item>
              <v-list-item-icon>
                <v-icon :color="getStatus(d).color">{{
                  getStatus(d).icon
                }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>{{$t('domains.status.title')}}</v-list-item-subtitle>
                <v-list-item-title>{{ getStatus(d).text }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action v-if="isOwner || isHelpdesk">
                <action-button v-if="d.active == 'PURGED'" :tooltip="$t('dialog.remove')" @click="removeDomain(d.id)" icon="$remove" />
              </v-list-item-action>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>$productFeed</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>{{$t('domains.productCount')}}</v-list-item-subtitle>
                <v-list-item-title>{{
                  formatNumber(d.stats.products)
              }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item  v-if="item.activeSubscription">
              <v-list-item-icon>
                <v-icon>$visitors</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('domains.monthlyVisitors', { date: formatDate(item.activeSubscription.from, true)})}}</v-list-item-subtitle
                >
                <v-list-item-title>{{
                  formatNumber(d.stats.monthlyUsers)
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        <v-list-item v-if="item.activeSubscription">
          <v-list-item-icon><v-icon>$sales</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle>{{$t('domains.sales', { date: formatDate(item.activeSubscription.from, true)})}}</v-list-item-subtitle>
            <v-list-item-title>{{ formatCurrencyAmount(d.stats.dreamroiSales, d.currency, 0) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else-if="loading">
      <v-col xs="12" md="6" lg="4" xl="3" v-for="(n,i) in Array(12)" :key="i">
      <v-card><v-skeleton-loader type="card-heading, list-item-avatar@3" /></v-card>
      </v-col>
    </v-row>
    <v-row v-else-if="list && list.length == 0 && !loading">
      <v-col>
      <v-alert 
      type="success" 
      border="left" 
      width="100%"
      colored-border
      >{{$t('domains.emptyList')}}</v-alert>
      </v-col>
    </v-row>
    
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import ParseRoute from "@/mixins/parse-route";
import DomainStatus from "@/mixins/domain-status";
import Formatters from "@/mixins/formatters";
import Wizards from '@/mixins/wizards';

export default {
  name: "Domains",
  mixins: [ParseRoute, DomainStatus, Formatters, Wizards],
  data() {
    return {
      loading: true
    };
  },
  computed: {
    isOwner() {
          return this.$store.getters['auth/isOwner']({ item: this.item })
    },
    ...mapState("companies", ["item"]),
    ...mapState("domains", ["list"]),
    ...mapGetters("auth", ["isHelpdesk"]),
  },
  methods: {
    loadDomains() {
      if (!this.list) {
        this.$store.dispatch("domains/list", { companyId: this.company }).then(() => {this.loading = false});
      } else {
        this.loading = false;
      }
    },
    async removeDomain(id) {
      this.loading = true;
      try {
        await this.$store.dispatch("domains/remove", { id });
        await this.$store.dispatch("domains/list", { companyId: this.company });
        this.$store.dispatch('ui/notify', { text: this.$t('domains.remove.success')});
      } catch {
        this.$store.dispatch('ui/notify', { text: this.$t('domains.remove.fail'), error: true });
      }
      this.loading = false;
    }
  },
  created() {
    this.loadDomains();
  },
  mounted() {
    this.exitWizard();
  }
};
</script>
